import { SuggestionContext } from "../components/SuggestionContextProvider"
import { useContext } from "react"

const useSuggestionContext = () => {
  return useContext(SuggestionContext)
}

export default useSuggestionContext
